import { Component, inject } from '@angular/core';
import { GlobalEventDispatcher } from '@ps20-frontend/shop-integration-redux';
import { NgRedux, select } from '@angular-redux3/store';
import { App } from '@ps20-frontend/frontend-models';
import { Observable } from 'rxjs';
import { LazyElementDirective } from '@angular-extensions/elements';
import { AsyncPipe } from '@angular/common';
import { IAppState } from '../../store/localStore';
import { loadAppConfig } from '../../store/local.actions';
import { appSourcePathConfigSelectorGenerator } from '../../store/selectors/app.selectors';

@Component({
  selector: 'ps20-shop-jhp-angebot-webcomponent-wrapper',
  templateUrl: './jhp-angebot.component.html',
  imports: [LazyElementDirective, AsyncPipe],
})
export class JhpAngebotComponent {
  globalEventDispatcher: GlobalEventDispatcher = GlobalEventDispatcher.getInstance();

  @select(appSourcePathConfigSelectorGenerator(App.JHP)) mainFilename$: Observable<string>;

  constructor() {
    const ngRedux = inject<NgRedux<IAppState>>(NgRedux);

    ngRedux.dispatch(loadAppConfig(App.JHP));
  }
}
